import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetHomeTermsParams = Required<operations['HomeTermsController_findAll']['parameters']>['query']
type ResListHomeTerms = components['schemas']['ResListHomeTerms']
type HomeTerms = components['schemas']['HomeTermsDto']

/**
 * 이용약관/처리방침 리스트 불러오기
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param termsType 이용약관/처리방침 구분
 * @returns ResListHomeTerms
 */
export const getHomeTerms = async ({ size = 100, offset = 0, termsType }: GetHomeTermsParams) => {
  return (await axios.get<ResListHomeTerms>('/homeTerms', { params: { size, offset, termsType } })).data
}

/**
 * 이용약관/처리방침 상세 조회
 * @param id 이용약관/처리방침 id
 * @returns HomeTermsDto
 */
export const getHomeTermsDetail = async (id: number) => {
  return (await axios.get<HomeTerms>(`/homeTerms/${id}`)).data
}
